import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import styles from './TextElement.module.scss';
export const TextElementInfoText = observer(({ $element }) => {
    const { config, renderParams } = $element;
    return (_jsxs("div", Object.assign({ className: classNames(styles.infoText, renderParams.className) }, { children: [_jsx(Icon, { type: 'info' }), " ", config.text] })));
});
export const TextElementInline = observer(({ $element }) => {
    const { config, renderParams } = $element;
    return _jsx("span", Object.assign({ className: classNames(styles.inline, renderParams.className) }, { children: config.text }));
});
export const TextElementDefault = observer(({ $element }) => {
    const { config, renderParams } = $element;
    return _jsx("div", Object.assign({ className: classNames(styles.default, renderParams.className) }, { children: config.text }));
});
